import { SgDashboardView } from '../features/sg-dashboard/SgDashboardView';

export default function DashboardPage() {
  return <SgDashboardView />;
}
